import React from 'react';
import { UncontrolledTooltip } from 'reactstrap';

import icons from '../../assets/icons';
import { getSolutionData } from '../../utils/solutions';
import { renderStatus } from '../../utils/tables';
import Pill from '../../components/pill';
import PillGroup from '../../components/pill/pillGroup';

const renderDeviceName = device => (
  <div className="ellipsis">
    <div id={`device-name-${device.id}`}>{device.displayName}</div>
    <UncontrolledTooltip placement="top" target={`#device-name-${device.id}`}>
      {device.displayName}
    </UncontrolledTooltip>
  </div>
);

const renderSolution = (solution, id) => {
  const solutionData = getSolutionData(solution);
  const tooltip = solutionData ? solutionData.name : 'none';

  return solution ? (
    <span>
      <img id={`icon-${id}`} className="solution-icon" src={icons[solutionData.name.toUpperCase()]} alt="" />
      <UncontrolledTooltip placement="left" target={`#icon-${id}`}>
        {tooltip}
      </UncontrolledTooltip>
    </span>
  ) : (
    '--'
  );
};

const renderSites = sites => {
  if (!sites || sites.length === 0) {
    return <span className={`status badge badge-pill badge-outline-secondary`}>No Site attached</span>;
  } else if (sites.length === 1) {
    return <Pill itemKey={sites[0].id} text={sites[0].displayName} tooltipText={sites[0].id} />;
  } else {
    const firstSite = {
      itemKey: sites[0].id,
      text: sites[0].displayName,
      tooltipText: sites[0].id
    };
    const sitesCounter = {
      itemKey: `sites-count-${sites.length}`,
      text: `+ ${sites.length - 1}`,
      tooltipText: `+ ${sites.length - 1} sites attached`
    };
    return <PillGroup pills={[firstSite, sitesCounter]} />;
  }
};

const renderId = id => {
  return <div className="left-aligned-item">{id}</div>;
};

const tableHeaders = [
  {
    Header: 'Name',
    id: 'displayName',
    type: 'string',
    accessor: d => renderDeviceName(d)
  },
  {
    Header: 'Solution',
    id: 'solutions',
    type: 'string',
    accessor: d => (d.solution ? renderSolution(d.solution, d.id) : d.solution),
    disableSortBy: true
  },
  {
    Header: 'Status',
    id: 'state.status',
    type: 'string',
    disableSortBy: true,
    accessor: d => {
      return renderStatus(d.status.toLowerCase());
    }
  },
  { Header: 'Site', id: 'sites', type: 'string', disableSortBy: true, accessor: d => renderSites(d.sites) },
  // {
  //   Header: 'Last Detection',
  //   id: 'state.lastDetectionTime',
  //   type: 'date',
  //   accessor: d =>
  //     d.state && d.state.lastDetectionTime ? (
  //       <div className="ellipsis">{formatDistanceToNowStrict(new Date(d.state.lastDetectionTime))} ago</div>
  //     ) : (
  //       '--'
  //     )
  // },
  // {
  //   Header: 'Version',
  //   id: 'state.malosVersion',
  //   type: 'version',
  //   disableSortBy: true,
  //   accessor: d => (d.state && d.state.malosVersion ? d.state.malosVersion : '--')
  // },
  {
    Header: 'Id',
    id: 'id',
    type: 'string',
    accessor: d => renderId(d.id),
    disableSortBy: true
  }
];

export default tableHeaders;
